/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Incorrect_Email_Or_PasswordInputs */

const en_auth_incorrect_email_or_password = /** @type {(inputs: Auth_Incorrect_Email_Or_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorrect email or password`)
};

const es_auth_incorrect_email_or_password = /** @type {(inputs: Auth_Incorrect_Email_Or_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electrónico o contraseña incorrectos`)
};

/**
* | output |
* | --- |
* | "Incorrect email or password" |
*
* @param {Auth_Incorrect_Email_Or_PasswordInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_incorrect_email_or_password = /** @type {((inputs?: Auth_Incorrect_Email_Or_PasswordInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Incorrect_Email_Or_PasswordInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_incorrect_email_or_password(inputs)
	return en_auth_incorrect_email_or_password(inputs)
});